import React from 'react'

import logoPrimary from '@assets/logo-primary.svg'
import logoWhite from '@assets/logo-white.svg'

type LogoProps = {
  className?: string
  light?: boolean
}

export function Logo({ className = '', light = false }: LogoProps) {
  const logo = light ? logoWhite : logoPrimary
  return (
    <div
      aria-label="iAct"
      className={`w-[5.4rem] ${className}`}
      dangerouslySetInnerHTML={{ __html: logo }}
    />
  )
}
